// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__DUsJW","inner":"List_inner__glqoy","accordeon_title":"List_accordeon_title__FESxW","cities":"List_cities__jRkcY"};